import { Component, OnInit } from '@angular/core';
import { BaseDisplay } from 'src/app/View/BaseUI/BaseDisplay';
import { Router } from '@angular/router';
import { GuestUserService } from '../../../../../Service/GuestUserService';
import { environment } from "../../../../../../environments/environment";

@Component({
	selector: 'app-home-component',
	templateUrl: './HomeFragmentComponent.html',
	styleUrls: ['./HomeFragmentComponent.scss'],
})
export class HomeFragmentComponent extends BaseDisplay {

	public eventShowMedicalService: any;
	public eventShowCreditService: any;
	public eventShowSettings: any;
	public eventShowReserve: any;

	// LINE友だち追加URL
	public lineFriendUrl = environment.LINE_FRIEND_URL;


	/**
	 * constructor
	 */
	constructor(public route: Router) {

		// Angulerのコンポーネントなので、上位を呼ぶ必要がある
		super();
	}

	/**
	 * 開始処理
	 */
	public async start() {

		// スワイプでロケーションバックを非活性にする
		this.disablePhoneSwipeBack();

	}

	public async onClickShowMedicalService() {
		await this.eventShowMedicalService();
	}

	public async onClickShowCreditService() {
		await this.eventShowCreditService();
	}

	public async onClickShowSettings() {
		await this.eventShowSettings();
	}

	public async onClickShowReserveService() {
		await this.eventShowReserve();
	}
}
